import { generateFontStyleFromSystem } from "../font-styles";
import { css } from "styled-components";
import { Lazy } from "lib/lazy";

const playfairFont = "Playfair Display, BlinkMacSystemFont, Roboto, sans-serif";
const latoFont = "Lato, BlinkMacSystemFont, Roboto, sans-serif";

export const editorialFontOverlay = new Lazy(() =>
    generateFontStyleFromSystem({
        AccentHeader: {
            weights: [700, 700, 700, 700, 700, 600, 600],
            fontFamily: playfairFont,
        },
        AccentSubheader: 600,
        AccentCallout: {
            weights: 500,
            fontFamily: playfairFont,
        },
        AccentBody: {
            weights: 500,
            fontFamily: playfairFont,
        },
        Header: {
            weights: [700, 700, 600, 500, 500, 500, 500],
        },
        Subheader: 600,
        Callout: 500,
        Body: 400,
        Caption: 400,
        Tag: {
            weights: 600,
            sizes: [22, 18, 15, 13, 11, 9, 8],
            css: css`
                text-transform: uppercase;
            `,
        },
        defaultFontFamily: latoFont,
        defaultFontSizes: [34, 24, 20, 16, 14, 12, 10],
        defaultLineHeights: [37, 29, 24, 19, 17, 17, 14],
        load: ["Playfair Display:400,500,600,700", "LOCAL-/fonts/lato/latofonts.css-Lato:n4,n5,n6,n7"],
    })
);
